import React, { HTMLAttributes } from 'react';
import { classes } from 'typestyle';
import { rowClass } from './index';

export function Row({ className, children, ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      {...props}
      className={classes(rowClass, className)}
    >
      {children}
    </div>
  );
}
